module.exports = {"420525101":"鸣凤镇","420525102":"花林寺镇","420525103":"旧县镇","420525104":"洋坪镇","420525105":"茅坪场镇","420525106":"嫘祖镇","420525201":"河口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420525.json
// module id = 1853
// module chunks = 0